import { Phototheque, CardFlipRevise, Pokedex, GestionnaireDeBibliotheque, FoodCollect, PokeGuess } from '../Images';

export const slidesData = [
	{ title: "Photothèque de Chatons", img: Phototheque, link: "/project/1" },
	{ title: "Card Flip Revise", img: CardFlipRevise, link: "/project/2" },
	{ title: "Pokedex", img: Pokedex, link: "/project/3" },
	{ title: "Gestionnaire de Bibliothèque", img: GestionnaireDeBibliotheque, link: "/project/4" },
	{ title: "Food Collect", img: FoodCollect, link: "/project/5" },
	{ title: "Poke Guess", img: PokeGuess, link: "/project/6" },

];